export default __webpack_public_path__ + "static/media/ceiling-mounted.51316f97.svg";